import Windows from '../components/Windows';
import {graphql} from 'react-apollo';
import gql from 'graphql-tag';
import {Window} from '../qql-shared/fragments';

const WindowsQuery = gql`
  query allWindows {
    allWindows {
      ...Window
    }
  }
  ${Window}
`;
const WindowQueryConfig = {
  options: () => ({
    fetchPolicy: 'network-only',
  }),
};
export default graphql(WindowsQuery, WindowQueryConfig)(Windows);



// WEBPACK FOOTER //
// ./src/containers/WindowsPage.js